var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-table', {
    staticClass: "table-outline mb-0",
    attrs: {
      "hover": "hover",
      "outline": "outline",
      "head-variant": "default",
      "items": _vm.data,
      "fields": _vm.label,
      "small": _vm.small,
      "fixed": "fixed"
    },
    on: {
      "row-clicked": _vm.editIntent
    },
    scopedSlots: _vm._u([{
      key: "intentId",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "intentTitle",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "intentAnswers",
      fn: function(item) {
        return [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-sm-9"
        }, [_c('b-collapse', {
          attrs: {
            "id": 'answerCollapse-' + item.index
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(item.value)
          }
        })]), (!item.item.answerCollapseIs) ? _c('span', [_vm._v(_vm._s(_vm.cutMessages(item.value)))]) : _vm._e()], 1), _c('div', {
          staticClass: "col-sm-3"
        }, [_c('b-btn', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle",
            value: (("answerCollapse-" + (item.index))),
            expression: "`answerCollapse-${item.index}`"
          }],
          staticClass: "float-left",
          staticStyle: {
            "background-color": "white",
            "border-color": "white"
          },
          on: {
            "click": function($event) {
              _vm.collapseAnswer(item)
            }
          }
        }, [(!item.item.answerCollapseIs) ? _c('i', {
          staticClass: "fa fa-chevron-down"
        }) : _vm._e(), (item.item.answerCollapseIs) ? _c('i', {
          staticClass: "fa fa-chevron-up"
        }) : _vm._e()])], 1)])]
      }
    }, {
      key: "noOfTrainings",
      fn: function(item) {
        return [_c('span', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "answerType",
      fn: function(item) {
        return [_c('span', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "quickReplies",
      fn: function(item) {
        return [(item.value === 'None') ? _c('div', {
          staticClass: "row"
        }, [_c('span', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.value))])]) : _vm._l((item.value), function(value) {
          return _c('div', {
            staticClass: "row"
          }, [_c('span', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(value))])])
        })]
      }
    }, {
      key: "noOfBubble",
      fn: function(item) {
        return [_c('span', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "show_details",
      fn: function(row) {
        return [_c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "size": "sm"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              row.toggleDetails($event)
            }
          }
        }, [_vm._v(_vm._s(row.detailsShowing ? 'Hide' : 'Show more'))])]
      }
    }, {
      key: "row-details",
      fn: function(row) {
        return [_c('b-card', [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-group', {
          attrs: {
            "label": "Questions / Triggering Bubble"
          }
        }, [_c('b-form-checkbox', {
          attrs: {
            "aria-describedby": "row.item.intentQuestions",
            "aria-constrol": "row.item.intentQuestions"
          },
          model: {
            value: (_vm.selectAllQuestions),
            callback: function($$v) {
              _vm.selectAllQuestions = $$v
            },
            expression: "selectAllQuestions"
          }
        }), _c('b-form-checkbox-group', {
          attrs: {
            "stacked": "stacked",
            "name": "Questions",
            "options": row.item.intentQuestions
          },
          model: {
            value: (_vm.selectedQuestions),
            callback: function($$v) {
              _vm.selectedQuestions = $$v
            },
            expression: "selectedQuestions"
          }
        })], 1)], 1), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-group', {
          attrs: {
            "label": "Quick Reply Bubble"
          }
        }, [_c('b-form-checkbox-group', {
          attrs: {
            "stacked": "stacked",
            "name": "QuickReplies",
            "options": row.item.quickReplies
          },
          model: {
            value: (_vm.selectedQuickReplies),
            callback: function($$v) {
              _vm.selectedQuickReplies = $$v
            },
            expression: "selectedQuickReplies"
          }
        })], 1)], 1)])])]
      }
    }, {
      key: "actions",
      fn: function(item) {
        return [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-btn', [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": [function($event) {
              _vm.removeIntent(item)
            }, function($event) {
              $event.stopPropagation();
            }]
          }
        }, [_vm._v(" Remove")])])], 1)])]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-566036fa","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IntentTable.vue
// module id = 1547
// module chunks = 1